var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var cio_datamodel = require("cio-datamodel");

var Editor2DModel = require("./../../editor2D/editor2DModel.js");
var DrawingStateMachine = require("./../../../abstract/stateMachines/drawingStateMachine.js");

var LineToolStateMachine = function (root, editorModel, selectionModel, getDataCollection, options) {
    this.root = root;
    this.getDataCollection = getDataCollection;
    this.options = options;

    DrawingStateMachine.call(this, root, editorModel, selectionModel);
};
lib_core.inherit(LineToolStateMachine, DrawingStateMachine);

module.exports = LineToolStateMachine;

LineToolStateMachine.prototype.createElement = function () {
    var line = new cio_datamodel.LineData(
            this.startCoord.x, this.startCoord.y,
            this.startCoord.x, this.startCoord.y,
            this.options.strokeWidth);

    line.addTo(this.getDataCollection());

    return this.getElementInteractionModel(line);
};

LineToolStateMachine.prototype.setElement = function (startCoord, currentCoord, keys) {
    var minSide, delta, cdelta;

    var constrainedDelta = function(delta) {
        minSide = Math.min(Math.abs(delta.x), Math.abs(delta.y));
        var angle = Math.round(delta.angle()/(Math.PI/4));

        var constrainedDelta;
        switch (angle) {
            case 0:
            case 4:
            case -4:
                constrainedDelta = new lib_geometry.Coord(delta.x, 0);
                break;
            case 1:
                constrainedDelta = new lib_geometry.Coord(minSide, minSide);
                break;
            case 2:
            case -2:
                constrainedDelta = new lib_geometry.Coord(0, delta.y);
                break;
            case 3:
                constrainedDelta = new lib_geometry.Coord(-minSide, minSide);
                break;
            case -1:
                constrainedDelta = new lib_geometry.Coord(minSide, -minSide);
                break;
            case -3:
                constrainedDelta = new lib_geometry.Coord(-minSide, -minSide);
                break;
        }
        return constrainedDelta;
    };

    if (keys.altKey === false && keys.shiftKey === false ) {
        this.element.p1(startCoord);
        this.element.p2(currentCoord);
    } else if (keys.altKey === true && keys.shiftKey === false) {
        delta = currentCoord.sub(startCoord);
        this.element.p1(startCoord.sub(delta));
        this.element.p2(currentCoord);
    } else if (keys.altKey === false && keys.shiftKey === true) {
        cdelta = constrainedDelta(currentCoord.sub(startCoord));
        this.element.p1(startCoord);
        this.element.p2(startCoord.add(cdelta));
    } else if (keys.altKey === true && keys.shiftKey === true) {
        cdelta = constrainedDelta(currentCoord.sub(startCoord));
        this.element.p1(startCoord.sub(cdelta));
        this.element.p2(startCoord.add(cdelta));
    }
};

LineToolStateMachine.prototype.setMinElement = function() {
    this.element.p2(this.element.p1().add(new lib_geometry.Coord(this.options.minLength,0)));
};
